import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "@vds/buttons";
import { Modal } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { deleteMediaEndPoint } from "../../configuration";
import { deleteMedia } from "../../model/mediaService";
import { Notification } from "@vds/notifications";

const CancelConfirmationModal = ({
  title,
  showModal = false,
  setShowModal,
  onSubmit,
}) => {
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleBack = () => {
    handleCloseModal();
  };

  const renderCancelContent = () => {
    return (
      <>
        <Title bold={true} size="medium">
          {title}
        </Title>
        <br />
        <br />
        <Body size="medium">
          <Notification
            type="warning"
            hideCloseButton={true}
            title="No information about this site will be saved if you cancel."
            subtitle="You progress will not be saved."
          />
        </Body>
        <div
          style={{
            marginTop: "5%",
            marginBottom: "5%",
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          <div style={{ width: "350px" }}>
            Are you sure you'd like to cancel?
          </div>
        </div>
        <div
          style={{
            marginBottom: "5%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="medium"
            width="45%"
            disabled={false}
            use="primary"
            data-testid="cancelConfirmationModal_yesButton"
            onClick={onSubmit}
          >
            Yes
          </Button>
          <Button
            size="medium"
            width="45%"
            disabled={false}
            use="secondary"
            data-testid="cancelConfirmationModal_noButton"
            onClick={handleBack}
          >
            No
          </Button>
        </div>
      </>
    );
  };

  return (
    <Modal
      opened={showModal}
      onOpenedChange={(opened) => {
        if (!opened) {
          handleCloseModal();
        }
      }}
      ariaLabel={title}
      disableOutsideClick={true}
    >
      {renderCancelContent()}
    </Modal>
  );
};

export default CancelConfirmationModal;
